import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const PolarityContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  overflow: visible;
`

export const PolarityHeader = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  cursor: ${({ $expanded }) => ($expanded ? 'default' : 'pointer')};
  flex-shrink: 0;
  border-radius: 12px 12px 0 0;
`

export const CompoundPolarityTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const PolarityGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PolarityDivider = styled.span`
  color: #9ca3af;
  font-weight: 400;
`

export const PolarityStatusSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SmallPolarityEmoji = styled.div`
  transform: scale(0.8);
  transform-origin: center;
`

export const ViewRulesButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: ${Tokens.ColorWhite};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 6px;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background-color: ${Tokens.ColorHover};
    border-color: ${Tokens.ColorUIPrimary};
    color: ${Tokens.ColorUIPrimary};
  }
`

export const PolarityTermsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  flex: none;
`

export const TermsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
`

export const TermSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
